import React from "react";
import PropTypes from "prop-types";

const ZoomIn = ({ height = "19", width = "18", viewBox = "0 0 18 19" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox={viewBox} fill="none">
      <path
        d="M14.6564 15.5617L9.94586 10.8509C9.57086 11.1605 9.13961 11.4029 8.65211 11.5779C8.16461 11.7529 7.6603 11.8404 7.13917 11.8404C5.8573 11.8404 4.77242 11.3965 3.88455 10.5089C2.99667 9.62129 2.55273 8.53667 2.55273 7.25504C2.55273 5.97354 2.99655 4.88854 3.88417 4.00004C4.7718 3.11167 5.85642 2.66748 7.13805 2.66748C8.41955 2.66748 9.50455 3.11142 10.393 3.99929C11.2814 4.88717 11.7256 5.97204 11.7256 7.25392C11.7256 7.78954 11.6357 8.30111 11.456 8.78861C11.2761 9.27611 11.0362 9.70011 10.7362 10.0606L15.4467 14.7712L14.6564 15.5617ZM7.13917 10.7155C8.10555 10.7155 8.92405 10.3802 9.59467 9.70942C10.2654 9.03879 10.6008 8.22029 10.6008 7.25392C10.6008 6.28754 10.2654 5.46904 9.59467 4.79842C8.92405 4.12767 8.10555 3.79229 7.13917 3.79229C6.1728 3.79229 5.3543 4.12767 4.68367 4.79842C4.01292 5.46904 3.67755 6.28754 3.67755 7.25392C3.67755 8.22029 4.01292 9.03879 4.68367 9.70942C5.3543 10.3802 6.1728 10.7155 7.13917 10.7155ZM6.57667 9.27311V7.81642H5.11998V6.69142H6.57667V5.23473H7.70167V6.69142H9.15836V7.81642H7.70167V9.27311H6.57667Z"
        fill="black"
      />
    </svg>
  );
};

ZoomIn.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  viewBox: PropTypes.string,
};

export default ZoomIn;
